import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ArrowRightIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9 12L13 8M13 8L9 4M13 8L5 8C3.89543 8 3 7.10457 3 6L3 4"
        stroke={fillColor || '#9D9DA6'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { ArrowRightIcon };
